import { useMutation } from '@apollo/client/react'
import { notification } from 'antd'
import { AssignTaggerDocumentsDocument } from '~app/graph/generated/graphql'
import i18n from '~app/i18n/i18n'

const useAssignDocuments = ({
  requestCount,
  where,
  refetch,
}: {
  requestCount: number
  where: Record<string, unknown>
  refetch: () => Promise<unknown>
}) => {
  const [assignTaggerDocuments] = useMutation(AssignTaggerDocumentsDocument)

  const assignDocumentsToTagger = async () => {
    try {
      const result = await assignTaggerDocuments({
        variables: {
          count: requestCount,
          where,
        },
      })
      const assignedDocuments = result.data?.assignTaggerDocuments.length
      if (assignedDocuments) {
        await refetch()
        notification.info({
          message: i18n.t('home.assignTagger.success'),
        })
      } else {
        notification.info({
          message: i18n.t('home.assignTagger.noAvailableDocuments'),
        })
      }
    } catch (_error) {
      notification.error({
        message: i18n.t('home.assignTagger.error'),
      })
    }
  }

  return assignDocumentsToTagger
}

export default useAssignDocuments
